export default __webpack_public_path__ + "static/media/rising-1.8375d8d8.jpg";